import React, {memo, useMemo} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {useOrientation} from '../../../hooks/orientation';
import {useCurrentGateway} from '../../../hooks/current-gateway';
import {hasAuthority} from '../../../utils/role';
import {Container} from '../../../components/Container';
import {UserRole} from '../../../types/control';
import {Link, useLocation} from 'react-router-dom';

import './index.scss';
import {useLocalization} from "../../../hooks/localization";
import {backButtonToggle, groupSettingAction} from "../../../store/ui/actions";
import { useChangeTheme } from '../../../hooks/change-theme';

export type Page = {
    icon: string;
    title: string;
    requiredRole: UserRole;
    routerLink: string;
};

type Props = {
    getPages: (gatewayId: string) => Page[];
    baseRoute?: string;
};

const MyButton = memo(function MyButton({icon, title, routerLink}: { icon?: string, title?: string, routerLink: string }) {
    const {t} = useLocalization();
    const {theme} = useChangeTheme()
    return (
        <Link className="button-container" to={routerLink}>
            <div className={`button ${theme === "rounded" ? "button-options" : ""}`}>
                <div className="button-img-container">
                    <img src={icon} alt="" />
                </div>
                <span>{t(title)}</span>
            </div>
        </Link>
    )
});

export const BaseSettingsScreenBase = memo(function BaseSettingsScreenBase({getPages, baseRoute}: Props) {
    const role = useSelector(state => state.ui.role);
    const orientation = useOrientation();
    const currentGateway = useCurrentGateway();
    const location = useLocation();
    const dispatch = useDispatch();
    if (location.pathname === '/developer') {
        dispatch(backButtonToggle({is_open: true, to: "/settings/advanced-settings"}))
    } else {
        dispatch(backButtonToggle({is_open: true, to: "/"}))
    }
    dispatch(groupSettingAction({visible: false}));

    const pages = useMemo(() => getPages(currentGateway?.id)
            .filter(page => hasAuthority(role, page.requiredRole)),
        [getPages, role, currentGateway?.id]);

    return (
        <Container className='no-sidebar'>
            <div className={'settings-page content-page ' + orientation}>
                <div className={'content-divider wrap ' + role}>
                    {
                        pages.map(page => (
                            <MyButton
                                key={page.title}
                                icon={page.icon}
                                title={page.title}
                                routerLink={`${baseRoute}${page.routerLink}`}/>
                        ))
                    }
                </div>
            </div>
        </Container>
    );
});
